"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fonts_1 = require("../../global/fonts");
const typography = {
    large: {
        mini: {
            ...fonts_1.AvenirNextRegular,
            size: 12,
            lineHeight: 16,
        },
        miniBold: {
            ...fonts_1.AvenirNextBold,
            size: 12,
            lineHeight: 16,
        },
        caption: {
            ...fonts_1.AvenirNextRegular,
            size: 14,
            lineHeight: 16,
        },
        captionBold: {
            ...fonts_1.AvenirNextBold,
            size: 14,
            lineHeight: 16,
        },
        body: {
            ...fonts_1.AvenirNextRegular,
            size: 16,
            lineHeight: 24,
        },
        bodyBold: {
            ...fonts_1.AvenirNextBold,
            size: 16,
            lineHeight: 24,
        },
        lead: {
            ...fonts_1.AvenirNextRegular,
            size: 18,
            lineHeight: 28,
        },
        overline: {
            ...fonts_1.AvenirNextBold,
            size: 14,
            lineHeight: 16,
            textTransform: 'uppercase',
        },
        displaySmall: {
            ...fonts_1.AvenirNextBold,
            size: 18,
            lineHeight: 28,
        },
        subheading: {
            ...fonts_1.AvenirNextBold,
            size: 20,
            lineHeight: 24,
        },
        displayMedium: {
            ...fonts_1.AvenirNextBold,
            size: 24,
            lineHeight: 30,
        },
        heading: {
            ...fonts_1.AvenirNextBold,
            size: 28,
            lineHeight: 32,
        },
        pageheading: {
            ...fonts_1.AvenirNextBold,
            size: 39,
            lineHeight: 48,
        },
        displayLarge: {
            ...fonts_1.AvenirNextBold,
            size: 48,
            lineHeight: 54,
        },
        callout: {
            ...fonts_1.GeorgiaRegularItalic,
            size: 18,
            lineHeight: 24,
        },
        code: {
            ...fonts_1.CourierNewBold,
            size: 18,
            lineHeight: 24,
        },
    },
    regular: {
        mini: {
            ...fonts_1.AvenirNextRegular,
            size: 12,
            lineHeight: 20,
        },
        miniBold: {
            ...fonts_1.AvenirNextBold,
            size: 12,
            lineHeight: 20,
        },
        caption: {
            ...fonts_1.AvenirNextRegular,
            size: 14,
            lineHeight: 20,
        },
        captionBold: {
            ...fonts_1.AvenirNextBold,
            size: 14,
            lineHeight: 20,
        },
        body: {
            ...fonts_1.AvenirNextRegular,
            size: 16,
            lineHeight: 24,
        },
        bodyBold: {
            ...fonts_1.AvenirNextBold,
            size: 16,
            lineHeight: 24,
        },
        lead: {
            ...fonts_1.AvenirNextRegular,
            size: 18,
            lineHeight: 32,
        },
        overline: {
            ...fonts_1.AvenirNextBold,
            size: 14,
            lineHeight: 20,
            textTransform: 'uppercase',
        },
        displaySmall: {
            ...fonts_1.AvenirNextBold,
            size: 18,
            lineHeight: 32,
        },
        subheading: {
            ...fonts_1.AvenirNextBold,
            size: 19,
            lineHeight: 24,
        },
        displayMedium: {
            ...fonts_1.AvenirNextBold,
            size: 23,
            lineHeight: 32,
        },
        heading: {
            ...fonts_1.AvenirNextBold,
            size: 25,
            lineHeight: 28,
        },
        pageheading: {
            ...fonts_1.AvenirNextRegular,
            size: 33,
            lineHeight: 44,
        },
        displayLarge: {
            ...fonts_1.AvenirNextBold,
            size: 40,
            lineHeight: 48,
        },
        callout: {
            ...fonts_1.GeorgiaRegularItalic,
            size: 18,
            lineHeight: 24,
        },
        code: {
            ...fonts_1.CourierNewBold,
            size: 18,
            lineHeight: 24,
        },
    },
    compact: {
        mini: {
            ...fonts_1.AvenirNextRegular,
            size: 12,
            lineHeight: 20,
        },
        miniBold: {
            ...fonts_1.AvenirNextBold,
            size: 12,
            lineHeight: 20,
        },
        caption: {
            ...fonts_1.AvenirNextRegular,
            size: 14,
            lineHeight: 20,
        },
        captionBold: {
            ...fonts_1.AvenirNextBold,
            size: 14,
            lineHeight: 20,
        },
        body: {
            ...fonts_1.AvenirNextRegular,
            size: 16,
            lineHeight: 24,
        },
        bodyBold: {
            ...fonts_1.AvenirNextBold,
            size: 16,
            lineHeight: 24,
        },
        lead: {
            ...fonts_1.AvenirNextRegular,
            size: 18,
            lineHeight: 24,
        },
        overline: {
            ...fonts_1.AvenirNextBold,
            size: 14,
            lineHeight: 20,
            textTransform: 'uppercase',
        },
        displaySmall: {
            ...fonts_1.AvenirNextBold,
            size: 18,
            lineHeight: 24,
        },
        subheading: {
            ...fonts_1.AvenirNextBold,
            size: 18,
            lineHeight: 24,
        },
        displayMedium: {
            ...fonts_1.AvenirNextBold,
            size: 20,
            lineHeight: 24,
        },
        heading: {
            ...fonts_1.AvenirNextBold,
            size: 23,
            lineHeight: 28,
        },
        pageheading: {
            ...fonts_1.AvenirNextRegular,
            size: 26,
            lineHeight: 32,
        },
        displayLarge: {
            ...fonts_1.AvenirNextBold,
            size: 32,
            lineHeight: 36,
        },
        callout: {
            ...fonts_1.GeorgiaRegularItalic,
            size: 18,
            lineHeight: 24,
        },
        code: {
            ...fonts_1.CourierNewBold,
            size: 18,
            lineHeight: 24,
        },
    },
};
exports.default = typography;
//# sourceMappingURL=typography.js.map